import { render, staticRenderFns } from "./BasicInfoStepper.vue?vue&type=template&id=541e48bf&scoped=true"
import script from "./BasicInfoStepper.vue?vue&type=script&lang=js"
export * from "./BasicInfoStepper.vue?vue&type=script&lang=js"
import style0 from "./BasicInfoStepper.vue?vue&type=style&index=0&id=541e48bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541e48bf",
  null
  
)

export default component.exports